export interface DashboardTotal_Previous_Current_PercentDTO {
  currencySymbol  : string;
  currentTotal    : number;
  percentageChange: number;
  previousTotal   : number;
};

export function DashboardTotal_Previous_Current_PercentDTO_EmptyObject(): DashboardTotal_Previous_Current_PercentDTO {
  return {
    currencySymbol  : "",
    currentTotal    : 0,
    percentageChange: 0,
    previousTotal   : 0
  }
};
